// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PointAnnotation {\n  pointer-events: none;\n}\n\n.Draw--not-drawing .PointAnnotation path {\n  pointer-events: visiblePainted;\n}\n\n.Draw--not-drawing .PointAnnotation--editable path {\n  cursor: move;\n}\n\n.Draw--is-pointer-down .PointAnnotation path {\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
